import React from 'react';
import { useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import StaffPack from "./StaffPack";
import StaffPackList from "./StaffPackList";

function PackagesHandler() {
    const businessId = useSelector((state) => { return (state.buisnessDetails.businessId) })
    return(
        <React.Fragment>
            <Switch>
            <Route path = {`/dashboard/${businessId}/Packages-and-Passes`} exact render = {() => {return(<StaffPackList />)}} />
            <Route path = {`/dashboard/${businessId}/Packages-and-Passes/:packIdURL`} render = {() => {return(<StaffPack />);}} />
            <Route path='*' render={() => { return (<Redirect to='/404' />) }} />
            </Switch>
        </React.Fragment>
    );
};

export default PackagesHandler;